
import React from 'react';
import ServiceAccordion from './ServiceAccordion';

const Services = () => {
  return (
    <section id="services" className="section-padding bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-semibold text-maroon mb-4">
            Focusing on Your Business
          </h2>
          <p className="text-charcoal-light text-lg max-w-2xl mx-auto">
            So you can focus on what matters most.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <h3 className="text-2xl font-heading text-charcoal mb-6">
              My services are designed to address your most pressing operational challenges
            </h3>
            <p className="text-charcoal-light mb-6">
              Whether you're struggling with inefficient workflows, team development, strategic planning, or data-driven decision making, I provide tailored solutions to help your business thrive.
            </p>
            <p className="text-charcoal-light">
              Each engagement is customized to your specific needs, ensuring maximum impact and sustainable results.
            </p>
          </div>
          <div className="lg:col-span-3">
            <ServiceAccordion />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
